var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14H17.5V0H0V14ZM8.75 9.0475L10.1062 7.875L14.4812 12.25H2.98375L7.35875 7.875L8.75 9.0475ZM11.375 6.67625L15.75 2.82625V11.0163L11.375 6.67625ZM8.75 6.67625L3.17625 1.75H14.3238L8.75 6.67625ZM6.125 6.67625L1.75 11.0512V2.82625L6.125 6.67625Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.47eb1765d95398d0c5ecbd89738b13ec.svg";
export { ForwardRef as ReactComponent };